<template>
  <el-col id="day-buttons" :span="24" style="margin-bottom: 8px">
    <el-row class="go-to-day-map">
      <el-button type="primary" @click.native="goToLoadDay">
        Подробнее
      </el-button>
    </el-row>
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'DayButtons',
  props: {
    bidId: {
      type: Number,
      default: 0,
    },
    day: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters({
      isDayLoading: 'bids/isDayLoading',
      getLoading: 'bids/getLoading',
    }),
    isStatusLoading() {
      return this.getLoading('Modal')
    },
  },
  methods: {
    goToLoadDay() {
      const { bidId, day } = this

      this.$router.push({
        name: 'LoadDay',
        params: { bidId, loadDayId: day.id },
      })
    },
  },
}
</script>

<style lang="sass">
#day-buttons
  .go-to-day-map
    margin-top: 20px
</style>
